
export const convertToTitleCase = (value: string) => {
    return value.replace(/_/g, ' ').replace(/\b\w/g, function(char) {
        return char.toUpperCase();
    });
}